module.exports = __webpack_public_path__ + "media/images/Funnel-01-90257f02a0a3f0dc0bb658824d038f42.svg";